import styled from "styled-components";

export const HeaderComplete = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #0f52ba;
  padding: 15px;

`;
export const LogoAll = styled.h1`
color: #fff;
font-weight: 600;
font-size: 30px;
margin-left: 40px;
`;
export const LogoOff = styled.strong`
color: #fff;
font-weight: 10;
font-size: 20px;
`;
export const TotalProducts = styled.p`
font-weight: 600;
font-size: 18px;
font-family: 'Raleway', sans-serif;
`